"use client";

import { Car, Plane, TrainFront as Train } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Location() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: infoRef,
    isVisible: infoVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const travelOptions = [{
    icon: Car,
    label: "CONSULTATION",
    detail: "Virtual or In-Person"
  }, {
    icon: Plane,
    label: "NATIONWIDE",
    detail: "Serving all 50 states"
  }, {
    icon: Train,
    label: "SUPPORT",
    detail: "Available 7 days a week"
  }];
  const compassPoints = [{
    label: "N",
    position: "top-4 left-1/2 -translate-x-1/2"
  }, {
    label: "E",
    position: "top-1/2 right-4 -translate-y-1/2"
  }, {
    label: "S",
    position: "bottom-4 left-1/2 -translate-x-1/2"
  }, {
    label: "W",
    position: "top-1/2 left-4 -translate-y-1/2"
  }];
  return <section data-section-id="4494" id="our-location" className="bg-slate-50 py-24 md:py-30 overflow-hidden">
      <div className="container mx-auto px-6">
        {}
        <div ref={headerRef} className={`max-w-4xl mx-auto text-center mb-16 md:mb-20 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default text-xs md:text-sm tracking-[0.3em] mb-6 font-bold text-orange-600">
            OUR REACH
          </p>
          <h1 className="font-default text-4xl md:text-6xl text-blue-900 leading-[1.1] mx-auto font-bold uppercase" style={{
          maxWidth: "22ch"
        }}>
            Expert <em className="italic text-blue-700">advocacy</em> for your major purchases.
          </h1>
          <p className="mt-8 text-xl text-gray-700 max-w-xl mx-auto font-default leading-relaxed">
            We provide professional negotiation services to ensure you get the best value, no matter where you are located.
          </p>
        </div>

        {}
        <div ref={mapRef} data-index={0} className={`relative transition-all duration-1000 ease-out ${mapVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="relative w-full rounded-lg overflow-hidden shadow-lg" style={{
          border: "1px solid #cccccc",
          aspectRatio: "16 / 9"
        }}>
            {}
            <svg viewBox="0 0 1600 900" className="w-full h-full block" preserveAspectRatio="xMidYMid slice" aria-label="Map showing service coverage area">
              {}
              <rect width="1600" height="900" fill="#ffffff" />

              {}
              <path d="M 0,200 Q 200,150 400,180 T 800,160 Q 1000,170 1200,140 T 1600,180 L 1600,900 L 0,900 Z" fill="#1a3a6b" opacity="0.05" />
              <path d="M 100,400 Q 300,350 500,380 Q 700,410 900,370 Q 1100,340 1300,380 Q 1450,400 1600,380 L 1600,900 L 0,900 L 0,420 Z" fill="#1a3a6b" opacity="0.08" />

              {}
              <ellipse cx="300" cy="550" rx="180" ry="120" fill="#1a3a6b" opacity="0.1" />
              <ellipse cx="1200" cy="600" rx="220" ry="140" fill="#1a3a6b" opacity="0.1" />

              {}
              <g transform="translate(800, 450)">
                <circle r="50" fill="#e87a27" opacity="0.15">
                  <animate attributeName="r" from="35" to="65" dur="2.5s" repeatCount="indefinite" />
                  <animate attributeName="opacity" from="0.3" to="0" dur="2.5s" repeatCount="indefinite" />
                </circle>
                <circle r="24" fill="#e87a27" />
                <circle r="22" fill="#ffffff" />
              </g>
            </svg>

            {}
            {compassPoints.map((point, i) => <div key={point.label} data-index={i} className={`absolute ${point.position} font-default text-[10px] md:text-xs tracking-[0.2em] text-blue-900`}>
                {point.label}
              </div>)}

            {}
            <div className="absolute bottom-4 right-4 md:bottom-6 md:right-6">
              <Link to="/AboutContactPage">
                <Button className="bg-orange-600 text-white rounded-lg font-default uppercase hover:bg-orange-700 shadow-md">
                  Contact Us
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {}
        <div ref={infoRef} className={`mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 transition-all duration-1000 ease-out ${infoVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {travelOptions.map((option, i) => {
          const Icon = option.icon;
          return <div key={option.label} data-index={i} className="flex flex-col items-center md:items-start text-center md:text-left">
                <Icon className="w-8 h-8 mb-4 text-blue-900" strokeWidth={1.5} />
                <p className="font-default text-xs tracking-[0.25em] mb-3 font-bold text-orange-600 uppercase">
                  {option.label}
                </p>
                <p className="font-default text-lg md:text-xl text-gray-900 leading-snug font-semibold">
                  {option.detail}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}